export const READ_TOKENS_FROM_FORAGE = 'USERS_TOKENS_READ_TOKENS_FROM_FORAGE'
export const RESET_TOKENS = 'USERS_TOKENS_RESET_TOKENS'
export const SET_TOKENS = 'USERS_TOKENS_SET_TOKENS'
// export const SET_ACCESSTOKEN = 'USERS_TOKENS_SET_ACCESSTOKEN'
// export const SET_REFRESHTOKEN = 'USERS_TOKENS_SET_REFRESHTOKEN'
export const REMOVE_TOKENS = 'USERS_TOKENS_REMOVE_TOKENS'



// WEBPACK FOOTER //
// ./src/features/Users/data/tokens/constants.js